/**
 * Assessment API calls
 */

import apiClient from './client.js';
import { Assessment, AssessmentWithQuestions, CreateAssessmentInput, PaginatedResponse } from '../../types/models';

export const assessmentsApi = {
  /**
   * List assessments
   */
  list: async (params?: {
    status?: string;
    source_type?: string;
    search?: string;
    page?: number;
    limit?: number;
    created_by?: string;
  }): Promise<PaginatedResponse<Assessment>> => {
    const response = await apiClient.get('/assessments', { params });
    return response.data;
  },

  /**
   * Get assessment by ID
   */
  getById: async (id: string): Promise<AssessmentWithQuestions> => {
    const response = await apiClient.get(`/assessments/${id}`);
    return response.data;
  },

  /**
   * Create assessment
   */
  create: async (data: CreateAssessmentInput): Promise<Assessment> => {
    const response = await apiClient.post('/assessments', data);
    return response.data;
  },

  /**
   * Update assessment
   */
  update: async (id: string, data: Partial<CreateAssessmentInput>): Promise<Assessment> => {
    const response = await apiClient.patch(`/assessments/${id}`, data);
    return response.data;
  },

  /**
   * Publish assessment
   */
  publish: async (id: string): Promise<Assessment> => {
    const response = await apiClient.post(`/assessments/${id}/publish`);
    return response.data;
  },

  /**
   * Archive assessment
   */
  archive: async (id: string): Promise<Assessment> => {
    const response = await apiClient.post(`/assessments/${id}/archive`);
    return response.data;
  },

  /**
   * Delete assessment
   */
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/assessments/${id}`);
  },

  /**
   * Upload assessment image
   */
  uploadImage: async (id: string, file: File): Promise<{ image_url: string }> => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await apiClient.post(`/assessments/${id}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * Delete assessment image
   */
  deleteImage: async (id: string): Promise<void> => {
    await apiClient.delete(`/assessments/${id}/image`);
  },
};
